const basePath = "/auth";

const loginRoute = `${basePath}/login`;
const refreshTokenRoute = `${basePath}/refresh-token`;
const logoutRoute = `${basePath}/logout`;
const revokeOtherSessionsRoute = `${basePath}/revoke-other-sessions`;
const registerSessionRoute = `${basePath}/register-session`;
const sessionsRoute = `${basePath}/sessions`;

export default {
  loginRoute,
  refreshTokenRoute,
  logoutRoute,
  revokeOtherSessionsRoute,
  registerSessionRoute,
  sessionsRoute,
};
